/**
 * 카테고리 → Material Icons 매핑
 * 기존 이모지 매핑을 1:1 대체
 */
const CATEGORY_ICON_MAP = {
  // 지출 카테고리 (모바일 CategoryContext 기준)
  '식비': 'restaurant',
  '주거비': 'home',
  '교통비': 'directions_bus',
  '통신비': 'phone_android',
  '공과금': 'lightbulb',
  '쇼핑': 'shopping_bag',
  '생활용품': 'cleaning_services',
  '뷰티/미용': 'face',
  '여행/레저': 'flight',
  '문화생활': 'movie',
  '의료/약국': 'local_hospital',
  '교육/강의': 'school',
  '경조사비': 'card_giftcard',
  '반려동물': 'pets',
  '금융/투자': 'credit_card',
  '기타': 'category',
  // 레거시 카테고리 (기존 거래 데이터 호환)
  '교통': 'directions_bus',
  '차량': 'directions_car',
  '마트/편의점': 'shopping_bag',
  '패션': 'checkroom',
  '미용': 'face',
  '주거': 'home',
  '통신': 'phone_android',
  '건강': 'local_hospital',
  '교육': 'school',
  '경조사': 'card_giftcard',
  '금융': 'credit_card',
  '세금': 'description',
  '여행': 'flight',
  '투자': 'trending_up',
  '기부/후원': 'volunteer_activism',
  // 기타 세부 카테고리 (키워드 매칭용)
  '카페': 'coffee',
  '디저트': 'cake',
  '외식': 'restaurant',
  '편의점': 'store',
  '마트': 'shopping_cart',
  '보험료': 'shield',
  '대출이자': 'account_balance',
  '주유비': 'local_gas_station',
  '주차비': 'local_parking',
  '택시': 'local_taxi',
  '지하철': 'subway',
  '병원비': 'local_hospital',
  '약값': 'medication',
  '헬스장': 'fitness_center',
  '운동': 'directions_run',
  '책': 'menu_book',
  '학원비': 'school',
  '영화': 'movie',
  '콘서트': 'music_note',
  '게임': 'sports_esports',
  '구독료': 'subscriptions',
  '화장품': 'face',
  '헤어샵': 'content_cut',
  '숙박': 'hotel',
  '항공료': 'flight',
  // 수입 카테고리
  '급여': 'work',
  '부업': 'computer',
  '투자수익': 'trending_up',
  '용돈': 'payments',
  '상여금': 'celebration',
  '포인트': 'star',
  '캐시백': 'currency_exchange',
  '이자수입': 'account_balance',
  '알바': 'person',
  '프리랜서': 'computer',
  '배당금': 'payments',
  '이자': 'account_balance',
  '환급': 'currency_exchange',
};

const DEFAULT_ICON = 'category';

/**
 * 카테고리 이름으로 Material Icons 아이콘 이름을 반환
 * @param {string} categoryName - 카테고리 이름
 * @returns {string} Material Icons 아이콘 이름
 */
export const getCategoryIcon = (categoryName) => {
  if (Object.prototype.hasOwnProperty.call(CATEGORY_ICON_MAP, categoryName)) return CATEGORY_ICON_MAP[categoryName];

  // 키워드 기반 폴백 매칭
  if (categoryName.includes('카페') || categoryName.includes('커피')) return 'coffee';
  if (categoryName.includes('식') || categoryName.includes('음식')) return 'restaurant';
  if (categoryName.includes('교통') || categoryName.includes('버스')) return 'directions_bus';
  if (categoryName.includes('병원') || categoryName.includes('의료')) return 'local_hospital';
  if (categoryName.includes('쇼핑') || categoryName.includes('구매')) return 'shopping_bag';
  if (categoryName.includes('옷') || categoryName.includes('의류')) return 'checkroom';

  return DEFAULT_ICON;
};

export default CATEGORY_ICON_MAP;
